import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DfteGridViewModule } from './features/dfte-grid-view/dfte-grid-view.module';
import { LegacyExtractModule } from './dcon-modules/legacy-extract/legacy-extract.module';
import { CloudExtractModule } from './dcon-modules/extract-from-cloud/cloud-extract.module';
import { ConfigCompareModule } from './dcon-modules/config-compare/config-compare.module';
import { ColudExtractLoadModule } from './dcon-modules/colud-extract-load/colud-extract-load.module';
import { MetaDataInsightsModule } from './dcon-modules/meta-data-insights/meta-data-insights.module';
import { ConfigWorkbookModule } from './dcon-modules/config-workbook-compare/config-workbook.module';
import { AboutComponent } from './shared/components/about/about.component';
import { ConfigBuildModule } from './dcon-modules/config-build/config-build.module';
import { FeatureFlagGuard } from './feature-flag.guard';

import { LoginModule } from './Login/login/login.module';

import { AdminModule } from './Admin/admin.module';
import { LoginComponent } from './Login/login/login.component';
import { AdminComponent } from './Admin/admin/admin.component';
import { basicAuthGuard } from './Admin/basic-auth.guard';
import { ToolbarComponent } from './shared/components/toolbar/toolbar.component';

const routes: Routes = [
  
  { path: 'login', component:LoginComponent },
  // { path: 'legacy-extract', loadChildren: () => LegacyExtractModule },
  { path: 'cloud-load', loadChildren: () => ColudExtractLoadModule , canActivate: [basicAuthGuard]},
  { path: 'cloud-extract', loadChildren: () => CloudExtractModule ,canActivate: [basicAuthGuard]},
  { path: 'config-workbook', loadChildren: () => ConfigWorkbookModule ,canActivate: [basicAuthGuard]},
  { path: 'config-compare', loadChildren: () => ConfigCompareModule,canActivate: [basicAuthGuard] },
  { path: 'metadata-extract', loadChildren: () => MetaDataInsightsModule,canActivate: [basicAuthGuard] },
  {
    path: 'config-build',
    loadChildren: () => ConfigBuildModule,
    canActivate: [FeatureFlagGuard,],
  },
  { path: 'admin', component:AdminComponent,canActivate: [basicAuthGuard] },
  { path: 'about', component: AboutComponent,canActivate: [basicAuthGuard] },
  { 
    path: '', 
    loadChildren: () => DfteGridViewModule,canActivate: [basicAuthGuard]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
 
];
// const routes: Routes = [
//   { path: '', loadChildren: () => DfteGridViewModule },
//   { path: 'login', loadComponent:()=>LoginModule },
//   //{ path: 'cloud-load', loadChildren: () => CloudExtractLoadModule }, // Fixed typo
//   { path: 'cloud-extract', loadChildren: () => CloudExtractModule },
//   { path: 'config-workbook', loadChildren: () => ConfigWorkbookModule },
//   { path: 'config-compare', loadChildren: () => ConfigCompareModule },
//   { path: 'metadata-extract', loadChildren: () => MetaDataInsightsModule },
//   {
//     path: 'config-build',
//     loadChildren: () => ConfigBuildModule,
//     canActivate: [FeatureFlagGuard],
//   },
//   { path: 'admin', loadChildren: () => AdminModule },
//   { path: 'about', component: AboutComponent },
//   { path: '**', redirectTo: '', pathMatch: 'full' }, // Optional: Add a dedicated 404 page
// ];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
